<template>
  <v-row>
    <v-col cols="12" class="pt-0">
      <v-row>
        <v-col class="py-0" cols="12" md="8">
          <product-details-form
            class="mb-3"
            :product="product"
            @change="changeDetails"
          />

          <scheduled-product-form
            v-if="isTemplateScheduledProduct()"
            class="mb-3"
            :product="product"
            @change="onChangeScheduleDetails($event)"
          />

<!--          <product-location-form-->
<!--            v-if="!isTemplateScheduledProduct()"-->
<!--            class="mb-3"-->
<!--            :product="product"-->
<!--            @change="changeLocation"-->
<!--          />-->

          <product-division-form
            v-if="isTemplateScheduledProduct()"
            class="mb-3"
            :product="product"
            @change="changeDivision"
          />

          <product-images-form
            :product="product"
            class="mb-3"
            @new-storage-path="onChangeStoragePath"
          />

          <product-default-taxes-form
            class="mb-3"
            :product="product"
            @change="changeTaxRates($event)"
          />

          <product-amount-quantity-form
            v-if="pricingMode === 'basic'"
            class="mb-3"
            :allow-price-mode-toggle="supportsBasicAndAdvancedPricing()"
            :product="product"
            @change="onChangeAmountOrQuantity($event)"
            @price-mode-toggle="togglePricingMode()"
          />

        </v-col>
        <v-col class="py-0" cols="12" md="4">
          <product-category-brand-form
            class="mb-3"
            :template="template"
            :product="product"
            @change="changeCategoryBrand"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="pt-0" cols="12">
          <product-options-variants-form
            v-if="shouldShowForm('combinations') && pricingMode === 'advanced'"
            :allow-price-mode-toggle="supportsBasicAndAdvancedPricing()"
            :template="template"
            :product="product"
            @price-mode-toggle="togglePricingMode()"
            @change-options="changeOptions"
            @change-variants="changeVariants"
          />
        </v-col>
      </v-row>

      <v-divider class="my-3"/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="isLoading"
          class="mr-3"
          rounded
          text
          outlined
          @click="$router.go(-1)"
        >
          Cancel
        </v-btn>

        <v-btn
          :loading="isLoading"
          rounded
          outlined
          color="primary"
          @click="save()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import { get } from 'lodash'
import ProductDetailsForm from "./ProductDetailsForm"
import ProductImagesForm from "./ProductImagesForm"
import ProductOptionsVariantsForm from "./ProductOptionsVariantsForm"
import ProductCategoryBrandForm from "./ProductCategoryBrandForm"
import ProductLocationForm from "./ProductLocationForm"
import ProductAmountQuantityForm from "./ProductAmountQuantityForm"
import ScheduledProductForm from "./ScheduledProductForm"
import ProductDivisionForm from "./ProductDivisionForm"
import ProductDefaultTaxesForm from "./ProductDefaultTaxesForm"

export default {
  components: {
    ProductDefaultTaxesForm,
    ProductDivisionForm,
    ScheduledProductForm,
    ProductAmountQuantityForm,
    ProductLocationForm,
    ProductCategoryBrandForm,
    ProductOptionsVariantsForm,
    ProductImagesForm,
    ProductDetailsForm
  },
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    template: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isLoading: false,
      model: {},
      variants: {},
      pricingMode: 'basic' // 'basic' or 'advanced'
    }
  },
  created() {
    this.model = {
      ...this.emptyModel(),
      ...this.product
    }

    // If the product has variants, assume advanced pricing mode
    this.pricingMode = get(this.product, 'variants', []).length > 0 ? 'advanced' : 'basic'
  },
  methods: {
    ...mapActions([
      'createProductAndVariants',
      'updateProductAndVariants'
    ]),
    onChangeStoragePath(path) {
      this.model.storagePath = path
    },
    supportsBasicAndAdvancedPricing() {
      return this.shouldShowForm('combinations')
    },
    togglePricingMode() {
      this.pricingMode = this.pricingMode === 'basic' ? 'advanced' : 'basic'
    },
    onChangeAmountOrQuantity(data) {
      this.model = { ...this.model, ...data }
    },
    onChangeScheduleDetails(data) {
      this.model = { ...this.model, ...data }
    },
    isTemplateScheduledProduct() {
      return get(this.template, 'id') === process.env.VUE_APP_SCHEDULED_PRODUCT_TEMPLATE_ID
    },
    shouldShowForm(type) {
      // Backwards compatibility, we only look for isHidden === true
      return get(this.template, `meta.${type}.isHidden`, false) !== true
    },
    changeTaxRates(data) {
      this.model.defaultTaxRates = data || []
    },
    changeDivision(data) {
      this.model.division = data
    },
    changeLocation(data) {
      const { label, coordinates } = data
      const { long, lat } = coordinates

      this.model = {
        ...this.model,
        location: {
          label,
          coordinates: { long, lat }
        }
      }
    },
    changeCategoryBrand(data) {
      const { category, brand } = data
      this.model = {
        ...this.model,
        category,
        brand,
      }
    },
    changeOptions(options) {
      this.options = { ...options }
    },
    changeVariants(variants) {
      this.variants = { ...variants }
    },
    changeDetails(details) {
      const { label, description } = details

      this.model = {
        ...this.model,
        label,
        description
      }
    },
    emptyModel() {
      return {
        id: this.id || undefined,
        label: '',
        description: '',
        storagePath: '',
        category: null,
        brand: null,
        location: {},
        division: null,
        defaultTaxRates: [],
        amount: 0,
        quantity: 0,
        duration: 0,
        deposit: 0,
        startPadding: 0,
        endPadding: 0,
        notifyMinutes: 0,
        notifyTypes: {},
        options: {
          1: null,
          2: null,
          3: null,
        }
      }
    },
    clear() {
      this.model = { ...this.emptyModel() }
    },
    onClose() {
      this.clear()
      this.$emit('close')
    },
    async save() {
      this.isLoading = true
      const productPayload = {
        ...this.model,
        options: this.options,
        template: this.template.id
      }

      // Variant payload needs to be prepared
      if (this.variants && this.pricingMode === 'advanced') {
        const saveVariants = Object.values(this.variants).filter(v => v.inMatrix === true)
        const deleteVariants = Object.values(this.variants).filter(v => v.inMatrix === false)

        productPayload.variants = { saveVariants, deleteVariants }
        productPayload.amount = 0
        productPayload.quantity = 0
      } else {
        // If the user is using basic pricing, delete all the variants
        productPayload.variants = { saveVariants: [], deleteVariants: Object.values(this.variants) }

        // Reset the options; Use an empty object as a fail safe
        productPayload.options = {}
      }

      if (this.product.id) {
        await this.updateProductAndVariants({ id: this.product.id, ...productPayload })
          .then(() => {
            this.$router.push({ name: 'products' })
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        await this.createProductAndVariants({ ...productPayload })
          .then(() => {
            this.$router.push({ name: 'products' })
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    }
  }
}
</script>
